import { Model } from '@/models/Model'

export class NetworkInformation extends Model {
	protected jsonApiType = 'networkInformationBerths'
}
